import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { appConfig } from "@/config";

export const Footer = () => {
  const logoUrl = appConfig.logoUrl || "logo_full.png";
  const ctaUrl = appConfig.ctaUrl || "https://app.serpbacklink.com";
  const ctaLabel = appConfig.footerCtaLabel || "Run Your First Batch";

  return (
    <footer data-testid="footer-section" className="border-t border-[#263248] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 text-center relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#F3F4F6]">
            Ready to scale your<br />SEO research?
          </h2>
          <a
            data-testid="footer-cta-button"
            href={ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#D4FF00] text-[#0B0F17] font-bold text-base hover:bg-[#E5FF66] active:bg-[#BCE600] transition-colors shadow-[0_0_40px_rgba(212,255,0,0.18)]"
          >
            {ctaLabel} <ArrowUpRight size={18} />
          </a>
        </motion.div>
      </div>

      <div className="border-t border-[#263248]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center" data-testid="footer-brand-logo">
            <img src={logoUrl} alt="serpbacklink" className="h-6 w-auto" />
          </div>
          <p data-testid="footer-copyright-text" className="font-mono2 text-xs text-[#6B7280]">
            &copy; 2026 SerpBacklink &middot; Metrics via the MOZ Links API &middot; Not affiliated with Moz
          </p>
        </div>
      </div>
    </footer>
  );
};
